// extracted by mini-css-extract-plugin
export default {"CircleImg":"style_CircleImg__ytGIS","defaultWidth":"style_defaultWidth__TmlXN","width100":"style_width100__C6jxs"};